import { Navigate, Outlet, useLocation } from "react-router-dom";

import { useAuth } from "../../features/auth/hooks/useAuth";

import LoadingOverlay from "../../shared/components/LoadingOverlay";

/**
 * Gate for every admin route. Two checks:
 *   1. authenticated (have an access token)
 *   2. two-factor enabled (mandatory for admins post-2026-05-15 incident)
 *
 * When (2) fails, we redirect to /setup-2fa-mandatory — a blocking page that
 * forces the admin to enrol TOTP before reaching any other backoffice route.
 * Without this, a leaked admin password (e.g. from a breach where the admin
 * reused credentials) is single-factor → game over on this panel.
 */

const ProtectedRoute = () => {
  const { isAuthenticated, isLoading, session } = useAuth();

  const location = useLocation();

  if (isLoading) {
    return <LoadingOverlay />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  const twoFactorEnabled = session.user?.twoFactorEnabled;

  const onEnrolmentPage = location.pathname === "/setup-2fa-mandatory";

  if (twoFactorEnabled === false && !onEnrolmentPage) {
    return <Navigate to="/setup-2fa-mandatory" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
